import { useHistory } from 'react-router';
import CloseButton from '../CloseButton';
import './style.scss';
import { CircularProgress, IconButton } from '@mui/material';
import { useState } from 'react';

const PageHeader = ({
    title,
    path = '/home',
    backable = false,
    onBack = () => ({}),
    style = {},
    closable = true,
    busy = false,
    closePath = null,
    subTitle = null,
    containerStyle = {}
}) => {
    const history = useHistory();

    const handleClose = () => {
        if (!closePath) {
            history.push(path);
        } else {
            history.push(closePath);
        }
    };

    return <div className='page-header' style={{ ...containerStyle }}>
        <div style={{
            display: 'flex',
            gap: 8,
            alignItems: 'center',
            ...style
        }}>
            {
                backable
                    ? <div>
                        <IconButton
                            onClick={onBack}
                            className='text-blue page-header__back'
                        >
                            <i
                                className="fa-regular fa-chevron-left"
                                style={{
                                    fontSize: 22
                                }}
                            />
                        </IconButton>
                    </div>
                    : null
            }
            <span className='page-header__title'>
                {
                    busy
                        ? <CircularProgress size={24} variant='determinate' />
                        : title
                }

                {
                    subTitle
                        ? <span className='page-header__sub-title'> - {subTitle}</span>
                        : null
                }
            </span>
        </div>
        {
            closable
                ? <span><CloseButton onClick={handleClose} /></span>
                : null
        }
    </div>;
};

export default PageHeader;